import { FUser } from 'libs/graphql/fragment/__generated__/FUser';
import { ActionType } from 'session/state/actions';
import { PartialDeep } from 'type-fest';

export interface SetLoggedUser {
    type: ActionType.SetLoggedUser;
    payload: {
        user: PartialDeep<FUser>;
        tokenType: string;
        accessToken: string;
    };
}

export interface SetUserChecked {
    type: ActionType.SetUserChecked;
    payload: {
        checked: boolean;
    };
}
export interface SetDbLikelyCrashed {
    type: ActionType.SetDbLikelyCrashed;
    payload: {
        dbLikelyCrashed: boolean;
    };
}

export const setLoggedUser = (
    user: PartialDeep<FUser>,
    tokenType?: string,
    accessToken?: string
): SetLoggedUser => ({
    type: ActionType.SetLoggedUser,
    payload: {
        user,
        tokenType,
        accessToken
    }
});

export const setUserChecked = (checked: boolean): SetUserChecked => ({
    type: ActionType.SetUserChecked,
    payload: {
        checked
    }
});

export const setDbLikelyCrashed = (dbLikelyCrashed: boolean): SetDbLikelyCrashed => ({
    type: ActionType.SetDbLikelyCrashed,
    payload: {
        dbLikelyCrashed
    }
});
